import { useParams } from 'react-router'

import type { EnumRouteParams } from '../system/types'

/** Helper hook for retrieving the Enum ID from the query params.*/
export const useEnumId = (): string => {
  const { enumId } = useParams<EnumRouteParams>()

  if (!enumId) {
    throw new Error('No enum ID was found')
  }

  return enumId
}
